import Constants from '../constants/FlightsConstants';
import NavigationConstants from '../constants/NavigationConstants';
import NotificationsConstants from '../constants/NotificationsConstants';
import TermsConstants from '../constants/TermsConstants';
import GlobalConstants from '../constants/GlobalConstants';
import GeneralConstants from '../constants/GeneralConstants';
import FlightsRemoting from '../../remoting/FlightsRemoting';
import StatusCodes from '../../model/StatusCodes';
import PassengersConstants from '../constants/PassengersConstants';
import AppConfiguration from '../../model/AppConfiguration';

/**
 *
 * @param {*} type - type constant (string)
 * @param {*} data - object, list or string
 */
function dispatchToReducer (type, data) {
  return {
    type: type,
    data: data,
  };
}

/**
 * getFlights called on client - getting all data for current step
 */
export function getFlights (request, reservationId, passengerId) {
  return dispatch => {
    dispatch(dispatchToReducer(Constants.GET_FLIGHTS_REQUEST));
    FlightsRemoting.getFlights(request, reservationId, passengerId)
      .then(response => {
        if (response && response.status === StatusCodes.UNKNOWN_ERROR) {
          console.error('Error occured: ', response.message);
          return dispatch(dispatchToReducer(Constants.GET_FLIGHTS_FAILURE, response));
        }

        if (response && response.status === StatusCodes.OK) {
          dispatch(
            dispatchToReducer(GeneralConstants.GENERAL_DATA_FETCHING_SUCCESS, response.data)
          );
          let flights = response.data && response.data.flights ? response.data.flights : [];
          let navigation =
            response.data && response.data.navigation ? response.data.navigation : null;
          if (navigation) {
            dispatch(dispatchToReducer(NavigationConstants.NAVIGATION_SUCCESS, navigation));
          }
          let notifications =
            response.data && response.data.notifications ? response.data.notifications : null;
          if (notifications) {
            dispatch(
              dispatchToReducer(NotificationsConstants.NOTIFICATIONS_SUCCESS, notifications)
            );
          }
          let passengers =
            response.data && response.data.passengers ? response.data.passengers : null;
          if (passengers) {
            dispatch(dispatchToReducer(PassengersConstants.PASSENGERS_SUCCESS, passengers));
          }
          let terms = response.data && response.data.terms ? response.data.terms : null;
          if (terms) {
            dispatch(dispatchToReducer(TermsConstants.TERMS_SUCCESS, terms));
          }
          return dispatch(dispatchToReducer(Constants.GET_FLIGHTS_SUCCESS, flights));
        }
      })
      .catch(error => {
        console.error('Error occured: ', error);
        return dispatch(dispatchToReducer(Constants.GET_FLIGHTS_FAILURE, error));
      });
  };
}

/**
 * updateFlights called to recover local redux state
 */
export function updateFlights (flights) {
  return dispatch => {
    dispatch(dispatchToReducer(Constants.UPDATE_FLIGHTS, flights));
  };
}

/**
 * submitFlights called on every step confirmation (next button) - saving current progress to server
 */
export function submitFlights (request, general, flights, step) {
  return dispatch => {
    dispatch(dispatchToReducer(Constants.SET_FLIGHTS_REQUEST));
    FlightsRemoting.setFlights(request, general, flights)
      .then(response => {
        if (response && response.status === StatusCodes.UNKNOWN_ERROR) {
          console.error('Error occured: ', response.message);
          return dispatch(dispatchToReducer(Constants.SET_FLIGHTS_FAILURE, response));
        }
        if (response && response.status === StatusCodes.OK) {
          dispatch(
            dispatchToReducer(GeneralConstants.GENERAL_DATA_FETCHING_SUCCESS, response.data)
          );

          let error;
          if (response && response.data && response.data) {
            const { goToTab, redirectUrl, notifications } = response.data;
            step = goToTab ? goToTab.toLowerCase() : step;
            step = redirectUrl || step;

            if (notifications && notifications.length) {
              error = notifications.find(
                notification => notification.type === NotificationsConstants.NOTIFICATION_ERROR
              );
              dispatch(
                dispatchToReducer(NotificationsConstants.NOTIFICATIONS_SUCCESS, notifications)
              );
            }
          }

          if (!error) {
            dispatch(dispatchToReducer(GlobalConstants.CHANGE_ACTIVE_STEP, step));
          }

          return dispatch(dispatchToReducer(Constants.SET_FLIGHTS_SUCCESS, response.data));
        }
      })
      .catch(error => {
        console.error('Error occured: ', error);
        return dispatch(dispatchToReducer(Constants.SET_FLIGHTS_FAILURE, error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/FlightsActions.js